<div *ngIf="errorMessage" class="row mb-3">
	<div class="col-12">
		<div class="alert alert-danger">
			{{ errorMessage }}
		</div>
	</div>
</div>

<div style="text-align: center; align-items: center; margin-top: 40px">
	<div class="col-lg-6" style="display: inline-block">
		<div class="card">
			<div class="card-header" style="text-align: left">
				<button
					(click)="approveBill()"
					[disabled]="inProgress || successed"
					class="btn btn-lg white-btn text-uppercase float-right mr-1"
					type="button"
					id="submit-button"
				>
					<i class="fas fa-file-invoice-dollar"></i> Approve Bill
				</button>
				<h4>
					Approve <b>{{ name }}</b> billing
				</h4>
			</div>

			<ngx-datatable
				*ngIf="!successed && !inProgress"
				#billingTable
				class="material fullscreen expandable"
				style="width: 100%"
				[rows]="rows"
				[loadingIndicator]="loadingIndicator"
				[columns]="columns"
				[columnMode]="'force'"
				[headerHeight]="50"
				[footerHeight]="50"
				[rowHeight]="45"
				[scrollbarH]="true"
				[reorderable]="reorderable"
				[limit]="50"
				[sorts]="[{ prop: 'start', dir: 'desc' }]"
			>
				<ngx-datatable-column name="Company" prop="org.org_name"></ngx-datatable-column>
				<ngx-datatable-column name="Start date" prop="start"></ngx-datatable-column>
				<ngx-datatable-column name="End date" prop="end"></ngx-datatable-column>
				<ngx-datatable-column name="Amount" prop="total"></ngx-datatable-column>
			</ngx-datatable>

			<div class="card-body" style="margin-top: 200px" *ngIf="!successed && inProgress">
				<div id="loader" style="margin-top: -15px"></div>
			</div>

			<div class="card-body" style="margin-top: 100px" *ngIf="successed && !inProgress">
				<h4>Invoice successfully sent to {{ name }}</h4>
			</div>
		</div>
	</div>
</div>
